.WorkflowDisplay {
  img {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  ul {
    list-style-type: none;
  }
  :global(.pointer) {
    cursor: pointer;
  }
  :global(.control) {
    padding-left: 4px;
    padding-bottom: 1px;
    margin-right: 4px;
    border: 1px solid var(--bs-gray-300);
    border-radius: 4px;
    cursor: pointer;
    background-color: var(--bs-gray-100);

    &:hover {
      background-color: var(--bs-gray-300);
    }
  }
}
